module.exports = __webpack_public_path__ + "static/img/智能分析云1.bf29a70d.png";